<template>
    <div class="kleptos">

        <!-- MENUBAR -->
        <KleptOSMenubar class="kleptos-header" :theme="theme"/>

        <!-- WRAPPER -->
        <div class="kleptos-body-wrapper">

            <!-- DESKTOP -->
            <KleptOSDesktop :theme="theme"/>

            <!-- SYSTEM -->
            <KleptOSWindowManager :theme="theme"/>

            <!-- TASKBAR -->
            <KleptOSTaskbar
                v-if="theme == 'theme-95'"
                class="kleptos-taskbar"
            />

            <!-- DOCK -->
            <KleptOSDock
                v-if="theme == 'theme-os'"
                class="kleptos-dock"
            />

        </div>
    </div>
</template>

<script>
    import Desktop from './Desktop/Desktop.vue';
    import Dock from './Dock/Dock.vue';
    import Menubar from './Menubar/Menubar.vue';
    import Taskbar from './Taskbar/Taskbar.vue';
    import WindowManager from './WindowManager/WindowManager.vue';

    export default {
        components: {
            KleptOSDesktop: Desktop,
            KleptOSDock: Dock,
            KleptOSMenubar: Menubar,
            KleptOSTaskbar: Taskbar,
            KleptOSWindowManager: WindowManager
        },
        props: {
            theme: {
                type: String,
                required: true
            },
        },
        created() {
            // spin up user FileSystem (based on theme) and add to store
            // BUT ah, the store must inform the app
            // the store will REPLACE current filesystem back to defaults


        }
    }
</script>

<style lang="scss" scoped>

    .kleptos {
        height: 100%; // [LOCKED] - prevents transition glitch
        background: black;
        z-index: 1; // [LOCKED] - unless controlled by chapter
    }

    .kleptos-body-wrapper {
        height: 100%; // [LOCKED]
    }

    .kleptos-header,
    .kleptos-dock,
    .kleptos-taskbar {
        z-index: 999; // [LOCKED]
    }
</style>